const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/server/app-render/clean-async-snapshot.external.js");